<template>
    <div id="vehicle_model_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleModelHeader" v-if="$route.params.id > 0">Update Asset Model</span>
                    <span class="page-title" id="vehicleModelHeader" v-else>Add Asset Model</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleModelList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-model-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VehicleModelForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="manufacturer_code">Manufacturer:</label>
                                        <v-select v-model="manufacturer_code" name="manufacturer_code" placeholder="Select Manufacturer."
                                            label="text"
                                            :options="manufacturercodeArr" id="manufacturer_code">
                                        </v-select>
                                        <div class="field-error">{{manufacturer_code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">    
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVehicleModelBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateVehicleModel" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createVehicleModelBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateVehicleModel" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueVehicleModelBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateVehicleModel(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelVehicleModelBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehicleModelList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

 



export default {
  name: "VehicleModelCreate",
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Asset Model | " +process.env.COPYRIGHT_NAME : "Create Asset Model | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    code: "",
    manufacturer_code: null,
    manufacturercodeArr: [],
    loading:false,
    name_error_msg: "",
    code_error_msg: "",
    manufacturer_code_error_msg: "",
  }),
  watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_model' ) {
                        self.cantAccessPage = true;

                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadVehicleManufacturer();
        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {
            self.loadVehicleModel();
        }
  },
  methods: {

    BackVehicleModelList() {
      var self = this;
      self.$router.push("/assetmodel/list");
    },

    CreateVehicleModel(flag) {
      var self = this;
      var error = false;

      self.code = self.code.trim();
      self.name = self.name.trim();

      self.code_error_msg = "";
      self.name_error_msg = "";
      self.manufacturer_code_error_msg = "";

      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code Required.";
        error = true;
      }

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
        error = true;
      }

      if (self.manufacturer_code == null || !self.manufacturer_code.value) {
        self.manufacturer_code_error_msg = "Manufacturer Required.";
        error = true;
      }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehicleModelBtn").val("Updating ...");
                $("#createVehicleModelBtn").prop("disabled", true);
                $("#cancelVehicleModelBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehicleModelBtn").val("Saving ...");
                    $("#createVehicleModelBtn").prop("disabled", true);
                    $("#createAndContinueVehicleModelBtn").prop("disabled", true);
                    $("#cancelVehicleModelBtn").prop("disabled",true);

                }else{

                    $("#createVehicleModelBtn").val("Saving ...");
                    $("#createVehicleModelBtn").prop("disabled", true);
                    $("#createAndContinueVehicleModelBtn").prop("disabled", true);
                    $("#cancelVehicleModelBtn").prop("disabled",true);
                }
               
            }
            var fields = $('#VehicleModelForm').serializeArray();
            fields.push({name: "vehicle_manufacturer_id", value: self.manufacturer_code.value});
            fields.push({name: "id", value: segments[3]});

            $.ajax({
                url: process.env.ROOT_API + "/assetmodel/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleModelBtn").val("Update");
                        $("#createVehicleModelBtn").prop("disabled", false);
                        $("#cancelVehicleModelBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleModelBtn").val("Save and Continue");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleModelBtn").val("Save");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");
                            self.name = "";
                            self.code = "";
                            self.manufacturer_code = null;
                            // self.manufacturercodeArr = "";

                        }else{
                            self.$router.push("/assetmodel/list");
                        }
                        
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleModelBtn").val("Update");
                        $("#createVehicleModelBtn").prop("disabled", false);
                        $("#cancelVehicleModelBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");
                            
                            $("#createAndContinueVehicleModelBtn").val("Save and Continue");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleModelBtn").val("Save");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-model-create')
                }
            });  
      }else{
          self.errorValidationFocus();
      }
    },

    loadVehicleModel() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assetmodel/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.code = data.content.code;
                    if(data.content.vehicle_manufacturer_id == null) {
                        self.manufacturer_code = null;
                    }else{
                        self.manufacturer_code = {value: data.content.vehicle_manufacturer_id, text: self.titleCase(data.content.vmName + " (" + data.content.vmCode +")")};
                    }   
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-model-load-by-id')
            }
        });
    },
    loadVehicleManufacturer() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/assetmanufacturer/search",
            type: "GET",
            headers: this.ajxHeaders,
            data:{flag:"json"},
            crossDomain: true,
            dataType: "json",
            success: function (data) {
                //console.log(data.content.email);
                if (data.status == "success") {

                    self.manufacturercodeArr = data.content.vehicle_manufacturers;
                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'asset-manufacture-search')
            }
        });
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/AssetModelCreate.vue